module.exports = __webpack_public_path__ + "img/35_42.723d6551.png";